module.exports = __webpack_public_path__ + "img/personal-hover.5275212a.svg";